import { render, staticRenderFns } from "./UploadIndividualIncomeTaxReturn.vue?vue&type=template&id=13f65140&"
import script from "./UploadIndividualIncomeTaxReturn.vue?vue&type=script&lang=ts&"
export * from "./UploadIndividualIncomeTaxReturn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports